import instance from "./request";


//新增数据配置
export const addConfigDetail = (data) => instance.post('/config/addConfigDetail', data)
//修改数据配置
export const editConfigDetail = (data) => instance.post('/config/editConfigDetail', data)
//数据配置详情
export const configDetailInfo = (id) => instance.get('/config/infoConfigDetail/' + id)
//修改数据删除
export const deleteConfigDetail = (data) => instance.post('/config/deleteConfigDetail', data)